import { api } from "@/utils/axios";

export const partService = {
  partTypeList(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_part&opt=part_type_list",
      body
    );
  },
  partList(body) {
    return api.post("?c=Port&m=Web_Port&module=Set_part&opt=part_list", body);
  },
  expendPart(body) {
    return api.post("?c=Port&m=Web_Port&module=Set_part&opt=expend_part", body);
  },
};
